import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-save-changes',
  templateUrl: './save-changes.component.html',
  styleUrls: ['./save-changes.component.scss']
})
export class SaveChangesComponent implements OnInit {

  public componentUrl: string;
  constructor(private dialogRef: MatDialogRef<SaveChangesComponent>,
    @Inject(MAT_DIALOG_DATA) public message:string) {

    }




  ngOnInit(): void {
  }
  onCancel(){
    this.dialogRef.close()
  }
}
